<template>
  <div
    class="cycle-type-tabs d-flex align-center"
    role="tablist"
    aria-label="Cycle type"
    data-testid="setup-tasklist__cycle-type-tabs"
  >
    <button
      v-for="cycle in cycleTypes"
      :key="cycle.id"
      type="button"
      class="cycle-type-tabs__chip"
      :class="{ 'cycle-type-tabs__chip--active': value === cycle.id }"
      :disabled="disabled"
      role="tab"
      :aria-selected="value === cycle.id"
      :data-testid="`setup-tasklist__cycle-type-tab--${cycle.id.toLowerCase()}`"
      @click="onSelect(cycle.id)"
    >
      <span class="cycle-type-tabs__label">{{ cycle.label }}</span>
      <span class="cycle-type-tabs__count" data-testid="setup-tasklist__cycle-type-count">
        {{ counts[cycle.id] || 0 }}
      </span>
    </button>
  </div>
</template>

<script>
import './CycleTypeTabs.scss';
import { CYCLE_TYPES } from '../../utils/taskListConstants';

export default {
  name: 'CycleTypeTabs',

  props: {
    value: {
      type: String,
      default: 'FBC',
    },
    counts: {
      type: Object,
      default: () => ({}),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    cycleTypes() {
      return CYCLE_TYPES;
    },
  },

  methods: {
    onSelect(id) {
      if (this.disabled || id === this.value) return;
      this.$emit('input', id);
      this.$emit('change', id);
    },
  },
};
</script>
